const { instance } = require('./url')

async function getManageableEmployees() {
    return await instance.get('/employee_verification/employees')
}

async function setAsanteRole(id, grant) {
    return await instance.put('/employee_verification/asante/' + id, {
        'grant': grant,
    })
}

async function setCustomerRole(id, grant) {
    return await instance.put('/employee_verification/customer/' + id, {
        'grant': grant,
    })
}

async function setVerified(id, verified) {
    return await instance.put('/employee_verification/verified/' + id, {
        'verified': verified,
    })
}

async function setCompany(id, company) {
    return await instance.put('/employee_verification/company/' + id, {
        'company': company,
    })
}

export {
    getManageableEmployees,
    setAsanteRole,
    setCustomerRole,
    setVerified,
    setCompany,
}
